import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import {NavigateBefore as NavPrevIcon, NavigateNext as NavNextIcon} from "@material-ui/icons";
import "./style.scss";

const PaginationBtns = props => {
  const {pagination, totalItems, goToPage, currentPage} = props;
  const lastOfSet = currentPage * pagination;
  const firstOfSet = lastOfSet - (pagination - 1);
  return (
    <React.Fragment>
      <div className={"pagination-btns " + props.className}>
        <div className="margin-right-15 pagination-count">
          {firstOfSet} - {lastOfSet > totalItems ? totalItems : lastOfSet}
          &nbsp; of&nbsp;
          {totalItems}
        </div>
        <Tooltip title="Next" placement="left-end">
          <IconButton
            className="btn-rounded-circle margin-right-5"
            size="sm"
            disabled={currentPage === 1}
            onClick={() => goToPage(currentPage - 1)}>
            <NavPrevIcon className="pagination-btn" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Next" placement="right-end">
          <IconButton
            className="btn-rounded-circle"
            size="sm"
            disabled={lastOfSet >= totalItems ? true : false}
            onClick={() => goToPage(currentPage + 1)}>
            <NavNextIcon className="pagination-btn" />
          </IconButton>
        </Tooltip>
      </div>
    </React.Fragment>
  );
};

export default PaginationBtns;



// WEBPACK FOOTER //
// ./src/components/PaginationBtns/index.jsx